import { SET_MARKETING_CARD_ON_CLICK_DATA } from "../store/mutation-types";

const MarketingCard = {
	setState: (self, data) => {
		self.$store.commit(SET_MARKETING_CARD_ON_CLICK_DATA, data);
	}
};
export const updateImagePaths = (obj, isMobileChannel, isSingleColumn = true) => {
	const width = isMobileChannel ? (isSingleColumn ? 400 : 200) : 800;

	const originalsOrMisc = /misc|marketingCards\/originals/gi;

	const replacePath = (path) => {
		if (!path) return path;

		// GIF and SVG need to use original version to prevent big quality loss
		if (/\.(gif|svg)$/i.test(path)) {
			return path.replace(originalsOrMisc, `marketingCards/originals`);
		}

		const pathChanged = path.replace(originalsOrMisc, `marketingCards/${width}`);
		return /originals/.test(pathChanged)
			? pathChanged
			: pathChanged.replace(/\.(jpg|jpeg|png)/i, ".webp");
	};

	const updateTemplate = (template) => {
		if (!template) return template;

		// GIF and SVG need to use original version to prevent big quality loss
		if (/\.(gif|svg)$/i.test(template)) {
			return template.replace(originalsOrMisc, `marketingCards/originals`);
		}

		const templateChanged = template.replace(originalsOrMisc, `marketingCards/${width}`);
		return /originals/.test(templateChanged)
			? templateChanged
			: templateChanged.replace(/\.(jpg|jpeg|png)/gi, ".webp");
	};

	const newObj = {
		...obj,
		template: obj.template ? updateTemplate(obj.template) : "",
		locales: {}
	};

	if (obj.locales && typeof obj.locales === "object") {
		for (const locale in obj.locales) {
			if (Object.prototype.hasOwnProperty.call(obj.locales, locale)) {
				const localeData = obj.locales[locale];
				newObj.locales[locale] = {
					...localeData,
					imagePath: replacePath(localeData.imagePath),
					template: updateTemplate(localeData.template)
				};
			}
		}
	}

	if(newObj.marketingCards && newObj.marketingCards.length){
		newObj.marketingCards = newObj.marketingCards.map(obj => updateImagePaths(obj, isMobileChannel, isSingleColumn));
	}

	return newObj;
};

export default MarketingCard;
